import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourcesStepsWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 24px;

  padding-bottom: 40px;

  ${BREAKPOINTS.tablet} {
    width: 100%;
    padding: 10px 0px 40px 0px;
  }

  position: relative;
`;
